var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 241,
    viewBox: "0 0 156 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231111 241V214.996L80.3111 131.644C88.8622 122.59 95.9111 114.657 101.458 107.846C107.081 100.958 111.28 94.4187 114.053 88.2273C116.827 82.0359 118.213 75.4576 118.213 68.4923C118.213 60.5983 116.364 53.7877 112.667 48.0607C108.969 42.2563 103.923 37.8062 97.5289 34.7105C91.1348 31.5374 83.9319 29.9509 75.92 29.9509C67.4459 29.9509 60.0504 31.6922 53.7333 35.1749C47.4163 38.6575 42.563 43.5719 39.1733 49.9181C35.7837 56.2643 34.0889 63.694 34.0889 72.2071H0C0 57.7347 3.31259 45.0811 9.93778 34.2462C16.563 23.4112 25.6533 15.0141 37.2089 9.05491C48.7645 3.0183 61.8993 0 76.6133 0C91.4815 0 104.578 2.97961 115.902 8.93882C127.304 14.8206 136.201 22.8694 142.596 33.0852C148.99 43.2237 152.187 54.6777 152.187 67.4475C152.187 76.2702 150.53 84.8995 147.218 93.3352C143.982 101.771 138.32 111.174 130.231 121.545C122.142 131.838 110.895 144.337 96.4889 159.041L49.4578 208.495V210.236H156V241H0.231111Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.7404fc955a1f044386e036d01d54040f.svg";
export { ForwardRef as ReactComponent };